



















import { Component, Vue } from "vue-property-decorator";

import Topbar from "@/components/Topbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import Footer from "@/components/Footer.vue";
// import SongFrom from "../modals/SongForm.vue";
import { helpers } from "../shared/helpers/helper.module";
import { appStore } from "../store/stores";

@Component({
  components: {
    Topbar,
    Sidebar,
    Footer
  }
})
export default class ProtectedPages extends Vue {
  get loading() {
    return helpers.isLoading;
  }

  mounted() {
    appStore.loadMusicPlatforms();
    appStore.loadGenres();
    appStore.loadConfiguration();
  }
}
